import { makeObservable, observable } from 'mobx';
import moment from 'moment';

export class KvAgtModel {
	constructor(opts: any) {
		makeObservable(this);
		this.id = opts.id;
		this.agtId = opts.aid;
		if (opts.agtId) {
			// fallback for other constructors
			this.agtId = opts.agtId;
		}
		this.bnrId = opts.bnrId;
		this.group = opts.groupId;
		this.key = opts.key;
		this.key2 = opts.key2;
		if (opts.n) {
			this.valueNum = opts.n;
		}
		if (opts.valueNum) {
			// fallback for other constructors
			this.valueNum = opts.valueNum;
		}

		if (opts.s) {
			this.valueString = opts.s;
		}
		if (opts.valueString) {
			// fallback for other constructors
			this.valueString = opts.valueString;
		}
	}

	agtId: number;
	bnrId: number;
	group: string;
	id: string;
	key: string;
	key2: string;

	@observable
	valueNum: number = 0;

	@observable
	valueString: string = '';

	static getString = (items: KvAgtModel[], key: string): string | undefined => {
		const item = items.find((i) => i.key === key);
		if (item) {
			return item.valueString;
		}
	};
	static getNumber = (items: KvAgtModel[], key: string): number | undefined => {
		const item = items.find((i) => i.key === key);
		if (item) {
			return item.valueNum;
		}
	};
	static getNumberDef = (items: KvAgtModel[], key: string): number => {
		const item = items.find((i) => i.key === key);
		if (item && item.valueNum) {
			return item.valueNum;
		}
		return 0;
	};
	static getProzDef = (items: KvAgtModel[], key: string): number => {
		const item = items.find((i) => i.key === key);
		if (item && item.valueNum) {
			return item.valueNum * 100;
		}
		return 0;
	};

	static getDate = (items: KvAgtModel[], key: string): Date | undefined => {
		const item = items.find((i) => i.key === key);
		if (item && item.valueNum) {
			return moment(item.valueNum).toDate();
		}
	};
}
